export default "<p>mobile-login works!</p>\r\n";